module.exports = __webpack_public_path__ + "img/htc_logo3.de6a99b8.jpeg";